import { FINGERPRINT_COOKIE, TOKEN_MAX_AGE } from '~/utils/auth'

/**
 * 取得穩定的 device fingerprint，存在 cookie。
 * 後端登入 / 已驗證請求需要 Fingerprint header 來綁定 device。
 * 第一次呼叫產生一組亂數並持久化，之後固定回同一個。
 *
 * 長度限制：後端 admin_device.id = `${admin_id}-${fingerprint}` 且該欄位為
 * varchar(32)。完整 uuid（36 字元）會讓 id 超長而 insert 失敗，故取 16 字元
 * hex（去掉 uuid 的 dash 後取前 16 碼），保留識別所需的熵又不會撐爆欄位。
 */
export function useFingerprint(): string {
  const cookie = useCookie<string | null>(FINGERPRINT_COOKIE, {
    maxAge: TOKEN_MAX_AGE.keepLogin,
    sameSite: 'lax',
    // secure 只在 production（https）開啟；dev 走 http://localhost，開了 cookie 會存不進去
    secure: !import.meta.dev,
  })
  if (!cookie.value) {
    cookie.value = crypto.randomUUID().replace(/-/g, '').slice(0, 16)
  }
  return cookie.value
}
